import { render, staticRenderFns } from "./OrganizationsList.vue?vue&type=template&id=30eed650&scoped=true"
import script from "./OrganizationsList.vue?vue&type=script&lang=js"
export * from "./OrganizationsList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsList.vue?vue&type=style&index=0&id=30eed650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__cac_3x63j6yfs4ywkbohjqsijm4vsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eed650",
  null
  
)

export default component.exports